var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('line-chart',{staticStyle:{"height":"1000px","max-height":"70vh"},attrs:{"chart-data":_vm.chartData,"options":_vm.options,"x-axis-ticks-min-rotation":60,"x-axis-ticks-max-rotation":60,"chart-title":_vm.title,"x-axis-label":"Age","y-axis-label":"Laying % vs Food"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baa31150","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layerAdmin/components/LayPercentageVsFoodChart.vue
// module id = null
// module chunks = 